// extracted by mini-css-extract-plugin
module.exports = {"outerFF-checkoutModal":"_3Mr15","headerWrap":"BRHpB","heading":"_2-OPW","modalContentWrapBreakup":"_2dmeH","sectionWrap":"_3NHFa","lastSection":"_1-LFL","sectionHeading":"_3lxoj"};